export default RAILS_ASSET_URL("/marker.png")
